export default "__VITE_ASSET__VbhWM9iC__"